import { createReducer } from '@reduxjs/toolkit';

import {
	bonusInitFailure,
	bonusInitRequest,
	bonusInitSuccess,
	collectBonusFailure,
	collectBonusRequest,
	collectBonusSuccess,
	collectedBonusEvent,
	hideCollectBonusAnimation,
} from './bonusActions';

type BonusState = {
	timer?: '00:00:00';
	loaded: boolean;
	bonusReady?: false;
	bonus?: any;
	loading: boolean;
	error?: string;
	collecting: boolean;

	daily?: [];

	lastCollectedChips?: number;
	showCollectAnimation: boolean;
};
const initial: BonusState = {
	loading: false,
	loaded: false,
	collecting: false,
	showCollectAnimation: false,
};

export const bonusReducer = createReducer(initial, bonusState => {
	bonusState.addCase(bonusInitRequest, state => {
		state.loading = true;
		state.error = undefined;
	});

	bonusState.addCase(bonusInitSuccess, (state, action) => {
		state.loading = false;
		state.loaded = true;
		state.bonus = {
			...state.bonus,
			...action.payload.bonus,
		};
	});

	bonusState.addCase(bonusInitFailure, (state, action) => {
		state.loading = false;
		state.error = action.payload;
	});

	bonusState.addCase(collectBonusRequest, state => {
		state.collecting = true;
		state.error = undefined;
	});

	bonusState.addCase(collectBonusSuccess, (state, action) => {
		state.collecting = false;
		state.lastCollectedChips = action.payload.chips;
		state.showCollectAnimation = true;
	});

	// Without this a failed collect left `collecting` set, and the Collect button greyed out
	// until the app was reloaded.
	bonusState.addCase(collectBonusFailure, (state, action) => {
		state.collecting = false;
		state.error = action.payload;
	});

	bonusState.addCase(hideCollectBonusAnimation, state => {
		state.showCollectAnimation = false;
	});

	bonusState.addCase(collectedBonusEvent, () => {});
});
